import { styled, css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Input = styled.input`
  height: 100%;
  width: 100%;
  opacity: 0;
  position: absolute;
  z-index: 0;
  cursor: pointer;
  margin: 0;
`

export const Label = styled.label`
  width: 18px;
  height: 18px;
  margin: auto;
  user-select: none;
  cursor: pointer;
  position: relative;
`

interface SpanProps {
  $checked: boolean
}

export const Span = styled.span<SpanProps>`
  width: 100%;
  height: 100%;
  display: inline-block;
  position: relative;
  border-radius: 3px;
  border: 2px solid ${({ theme }) => theme.colors.grayAccent};
  background-color: ${({ theme }) => theme.colors.white};
  transition: all 0.2s ease;
  box-sizing: border-box;

  svg {
    position: absolute;
    top: 3px;
    left: 2px;
    fill: none;
    stroke: #ffffff;
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-dasharray: 16px;
    stroke-dashoffset: 16px;
    transition: all 0.2s ease;
    transition-delay: 0.2s;
  }

  &:hover {
    ${({ $checked, theme }) =>
      !$checked &&
      css`
        border-color: ${theme.colors.primary};
        background-color: ${theme.colors.grayAccent};

        svg {
          stroke: ${theme.colors.grayAccent};
        }
      `}
  }

  ${({ $checked, theme }) =>
    $checked &&
    css`
      background: ${theme.colors.primary};
      border-color: ${theme.colors.primary};

      svg {
        stroke-dashoffset: 0;
      }
    `}
`
